import React from "react";
import "./stylesheets/css/game.css";
import {
  Typography,
  ButtonBase,
  Icon,
  TextField,
  withStyles,
  InputBase,
  IconButton,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Divider,
  LinearProgress
} from "@material-ui/core";
import {
  Done,
  Clear,
  ArrowForward,
  ArrowBack,
  Delete,
  ExitToApp
} from "@material-ui/icons";
import $ from "jquery";
import { getRandomWord, submitCorrectWord } from "../services/FetchData";
import { Redirect } from "react-router-dom";
import MyAppBar from "../AppComponents/MyAppBar";
import TypingGame from "./TypingGame";

import KeyboardGame from "./KeyboardGame";

class Game extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      words: [],
      counter: -1,
      correctedWord: "",
      correctCounter: 0,
      incorrectCounter: 0,
      removeCounter: 0,
      showThanks: false,
      loading: false,

      redirect: false,
      id:
        localStorage.getItem("auth_token") === null
          ? "game"
          : localStorage.getItem("auth_token"),
      name:
        localStorage.getItem("user_name") === null
          ? "game"
          : localStorage.getItem("user_name")
    };
  }

  componentDidMount() {
    this.printNextWord();
  }

  componentWillMount() {
    if (
      localStorage.getItem("user_status") === null ||
      localStorage.getItem("user_status") !== "logged_in"
    ) {
      this.setState({ redirect: true });
    }
  }

  correct = () => {
    // ? if not at the end of words[], submit query and traverse
    // ? if at the end of words[], submit and fetch new word

    // * if -> not at the end; else -> at the end;
    if (this.state.counter < this.state.words.length - 1) {
      this.setState({
        loading: true
      });

      // * query to submit
      $.ajax({
        type: "POST",
        url: submitCorrectWord,
        data: {
          id: this.state.id,
          name: this.state.name,
          word: this.state.words[this.state.counter],
          suggested_word: this.state.correctedWord,
          action: "correct"
        },
        success: function(res) {
          console.log(res);

          // * increase correct counter
          this.setState({
            counter: this.state.counter + 1,
            correctCounter: this.state.correctCounter + 1,
            loading: false
          });
        }.bind(this),
        error: function(err) {
          console.log(err);

          this.setState({
            loading: false
          });
        }.bind(this)
      });
    } else {
      // * show loading
      this.setState({
        loading: true
      });

      // * query to correct
      $.ajax({
        type: "POST",
        url: submitCorrectWord,
        data: {
          id: this.state.id,
          name: this.state.name,
          word: this.state.words[this.state.counter],
          suggested_word: this.state.correctedWord,
          action: "correct"
        },
        success: function(res) {
          console.log(res);

          // * increase correct counter
          this.setState({
            correctCounter: this.state.correctCounter + 1,
            loading: false
          });

          // * print next word
          this.printNextWord();
        }.bind(this),
        error: function(err) {
          console.log(err);

          this.setState({
            loading: false
          });
        }.bind(this)
      });
    }
  };

  incorrect = () => {
    // *

    // * query to submit
    $.ajax({
      type: "POST",
      url: submitCorrectWord,
      data: {
        id: this.state.id,
        name: this.state.name,
        word: this.state.words[this.state.counter],
        suggested_word: this.state.correctedWord,
        action: "incorrect"
      },
      success: function(res) {
        console.log(res);
        // * increase incorrect counter
        this.setState({
          incorrectCounter: this.state.incorrectCounter + 1
        });

        // * print next word
        this.printNextWord();
      }.bind(this),
      error: function(err) {
        console.log(err);

        this.setState({
          loading: false
        });
      }.bind(this)
    });
  };

  remove = () => {
    // todo query to submit
    $.ajax({
      type: "POST",
      url: submitCorrectWord,
      data: {
        id: this.state.id,
        name: this.state.name,
        word: this.state.words[this.state.counter],
        suggested_word: this.state.correctedWord,
        action: "remove"
      },
      success: function(res) {
        console.log(res);
        // * increase incorrect counter
        this.setState({
          removeCounter: this.state.removeCounter + 1
        });

        // * print next word
        this.printNextWord();
      }.bind(this),
      error: function(err) {
        console.log(err);

        this.setState({
          loading: false
        });
      }.bind(this)
    });
  };

  skip = () => {
    if (this.state.counter < this.state.words.length - 1) {
      this.setState({
        counter: this.state.counter + 1
      });
    } else {
      this.printNextWord();
    }
  };

  back = () => {
    if (this.state.counter !== -1) {
      this.printPreviousWord();
    }
  };

  printNextWord = () => {
    this.setState({
      loading: true
    });

    $.ajax({
      type: "GET",
      url: getRandomWord,
      data: {},
      success: function(res) {
        console.log(res);

        if (res.length > 30) {
          this.setState({
            loading: false
          });
        } else {
          this.setState({
            words: [...this.state.words, res],
            counter: this.state.counter + 1,
            loading: false,
            correctedWord: ""
          });
        }
      }.bind(this),
      error: function(err) {
        console.log(err);

        this.setState({
          loading: false
        });
      }.bind(this)
    });
  };

  printPreviousWord = () => {
    this.setState({
      counter:
        this.state.counter === 0
          ? this.state.words.length - 1
          : this.state.counter - 1
    });
  };

  render() {
    const { classes } = this.props;

    if (
      this.state
        .redirect /*|| localStorage.getItem("user_status") === "logged_in"*/
    ) {
      return (
        <Redirect to={"/"} />
        //<Route path={"/search"} component={MenuOptions}/>
      );
    }

    return (
      <div id="game-master">
        <MyAppBar />
        {/* <KeyboardGame /> */}

        {this.state.loading && (
          <div style={{ position: "relative", top: 0, left: 0, width: "100%" }}>
            <LinearProgress color="secondary" />
          </div>
        )}

        <div id="game-word">
          <div id="word">
            <Typography variant="h3" component="p">
              {this.state.words[this.state.counter]}
            </Typography>
          </div>

          <div id="counter">
            <Typography variant="h3" component="p">
              {this.state.counter + 1} / {this.state.words.length}
            </Typography>
          </div>
        </div>

        <div id="textfield">
          <Paper className={classes.root} elevation={1}>
            <InputBase
              className={classes.input}
              placeholder="Submit your suggestion"
              value={this.state.correctedWord}
              onChange={event => {
                this.setState({
                  correctedWord: event.target.value
                });
              }}
              // onKeyDown={event =>
              //    event.keyCode === 13
              //       ? this.submitCorrectWord("keyboard", event)
              //       : null
              // }
            />
            {/* <IconButton
                     className={classes.iconButton}
                     aria-label="Search"
                     onClick={event => this.submitCorrectWord("mouse", event)}
                  >
                     <ArrowForward />
                  </IconButton> */}
          </Paper>
        </div>

        <div id="game-buttons">
          <div id="button-center">
            <ButtonBase focusRipple id="correct" onClick={this.correct}>
              <section>
                <Done fontSize="large" />
                <Typography variant="h4" component="p">
                  Correct
                </Typography>
              </section>
            </ButtonBase>
            <ButtonBase focusRipple id="incorrect" onClick={this.incorrect}>
              <section>
                <Clear fontSize="large" />
                <Typography variant="h4" component="p">
                  Incorrect
                </Typography>
              </section>
            </ButtonBase>

            <ButtonBase focusRipple id="remove" onClick={this.remove}>
              <section>
                <Delete fontSize="large" />
                <Typography variant="h4" component="p">
                  Remove
                </Typography>
              </section>
            </ButtonBase>

            <ButtonBase focusRipple id="skip" onClick={this.skip}>
              <section>
                <ArrowForward fontSize="large" />
                <Typography variant="h4" component="p">
                  Skip
                </Typography>
              </section>
            </ButtonBase>
            <ButtonBase focusRipple id="back" onClick={this.back}>
              <section>
                <ArrowBack fontSize="large" />
                <Typography variant="h4" component="p">
                  Go back
                </Typography>
              </section>
            </ButtonBase>
            <ButtonBase
              focusRipple
              id="exit"
              onClick={() => this.showDialog(true)}
            >
              <section>
                <ExitToApp fontSize="large" />
                <Typography variant="h4" component="p">
                  Exit
                </Typography>
              </section>
            </ButtonBase>
          </div>
        </div>

        {this.state.showThanks && (
          <AlertDialogSlide
            open={this.state}
            cancel={() => this.showDialog(false)}
          />
        )}
        {/* <TypingGame /> */}
      </div>
    );
  }

  showDialog = action => {
    this.setState({
      showThanks: action
    });
  };

  exitWindow = () => {
    window.close();
  };
}

const styles = {
  root: {
    // padding: "2px 4px",
    display: "flex"
    // alignItems: "center",
    // width: "100%"
  },
  input: {
    marginLeft: 8,
    padding: 10,
    // width: "100%",
    // display: "flex",
    flex: 3
  },
  iconButton: {
    padding: 10
    // flex: 1
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4
  }
};

export default withStyles(styles)(Game);

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class AlertDialogSlide extends React.Component {
  // state = {
  //    open: this.props.open
  // }

  handleClose = () => {
    // this.setState({ open: false })
    this.props.cancel(false);
  };

  render() {
    const propsFromParent = this.props.open;
    return (
      <div>
        <Dialog
          fullWidth={true}
          open={this.props.open.showThanks}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            {"Thanks for contributing to Aakhor!"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Your stats for the session:
            </DialogContentText>

            <Divider style={{ margin: "20px 0" }} />

            <DialogContentText id="alert-dialog-slide-description">
              Checked words: {propsFromParent.words.length}
            </DialogContentText>

            <Divider style={{ margin: "20px 0" }} />

            <DialogContentText id="alert-dialog-slide-description">
              Correct words: {propsFromParent.correctCounter}
            </DialogContentText>

            <Divider style={{ margin: "20px 0" }} />

            <DialogContentText id="alert-dialog-slide-description">
              Corrected words: {propsFromParent.incorrectCounter}
            </DialogContentText>

            <Divider style={{ margin: "20px 0" }} />

            <DialogContentText id="alert-dialog-slide-description">
              Suggested removal of words: {propsFromParent.removeCounter}
            </DialogContentText>

            <Divider style={{ margin: "20px 0" }} />

            <DialogContentText id="alert-dialog-slide-description">
              Safely close the tab with CTRL+W or CMD+W.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            {/* <Button onClick={this.exit} color="primary">
                     Exit
                  </Button> */}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
